import React, { FC } from 'react';
import { CrewListContainerStyled, CrewListItemStyled, CrewBulletStyled } from '../styled';
import { map } from 'lodash';
import { CrewProgressTreeItem } from './item';
import { CrewProgressStats } from '@bechtel/types';

interface CrewProgressTreeProps {
  depth: number;
  data: CrewProgressStats[];
}
export const CrewProgressTree: FC<CrewProgressTreeProps> = ({ depth, data }) => {
  return (
    <CrewListContainerStyled data-testid="crew-list-container">
      {map(data, (stat) => {
        return (
          <CrewListItemStyled key={stat?.crewMember?.id}>
            {depth != 0 && <CrewBulletStyled data-testid="crew-bullet" />}
            {/* No need for bullet at the root */}
            <CrewProgressTreeItem weldStatsByPersona={stat} depth={depth + 1} />
          </CrewListItemStyled>
        );
      })}
    </CrewListContainerStyled>
  );
};
